import mixpanel from 'mixpanel-browser';

const MIXPANEL_ENABLED = false;

export function trackMixpanel(name, data) {
    if (!MIXPANEL_ENABLED) return;
    try {
        mixpanel.track(name, data);
    } catch (exp) {
        console.warn(`Could not track mixpanel event: ${name}, exp: ${exp}`)
    }
}

